import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "./ChartCard";


const axisNameColor = '#334155';
const labelColor = '#475569'
const axisLineColor = '#7798c3b4'
const axisLineWidth = 2;
const legendLabelColor = '#777c83'



const BarChart = ({
    chartLabel,
    chartData = [],
    xField,
    yField,
    tooltipFields = [],
    barColor = "#3B82F6",
    height = 420,
    rotateLabel = 25,
    yAxisTitle = "",
    fieldsLabel = "",
    purpose = "",
    seriesLabel,
    xAxisTitle = ''

}) => {


    const graphData =
        Array.isArray(chartData) && chartData?.length > 0
            ? chartData
            : [];

    const option = {
        tooltip: {
            trigger: "axis",
            axisPointer: {
                type: "shadow",
            },

            formatter: (params) => {
                if (!params?.length) return "";
                const item = graphData[params[0].dataIndex];
                let html = "";
                if (purpose) {
                    html += `<b>Purpose</b><br/>${purpose}<br/><br/>`;
                }
                // html += `<b>${item[xField]}</b><br/>`;
                tooltipFields.forEach(field => {
                    let value = item[field.key];

                    if (
                        value &&
                        (field.key?.toLowerCase().includes("date") ||
                            value.toString().includes("T"))
                    ) {
                        const date = new Date(value);
                        value = `${String(date.getDate()).padStart(2, "0")}-${String(
                            date.getMonth() + 1
                        ).padStart(2, "0")}-${date.getFullYear()}`;
                    }

                    html += `<b>${field.label}</b> : ${1}<br/>`;
                });

                if (fieldsLabel) {
                    html += `<hr style="margin:6px 0"/>`;
                    html += `<b>Fields</b><br/>${fieldsLabel}`;
                }

                return html;
            },
        },
        legend: {
            show: true,
            top: 5,
            left: "center",
            data: [seriesLabel],
            textStyle: {
                fontSize: 12,
                fontWeight: 600,   // or 600, 700
                color: legendLabelColor,
            },
        },

        grid: {
            left: "6%",
            right: "3%",
            top: "10%",
            bottom: "18%",
            containLabel: true,
        },

        xAxis: {
            type: "category",
            name: xAxisTitle,
            nameLocation: "middle",
            nameGap: 50,
            data: graphData?.map((item) => {
                const value = item?.[xField];
                if (!value) return "";
                return typeof value === "string"
                    ? value.split(" ")[0]
                    : value;

            }),

            axisTick: {
                show: false,
            },

            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },

            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },

            axisLabel: {
                rotate: rotateLabel,
                color: labelColor,
                fontSize: 11,
            },

            splitLine: {
                show: false,
            },
        },

        yAxis: {
            type: "value",
            name: yAxisTitle,
            nameLocation: "middle",
            nameGap: 35,
            nameTextStyle: {
                fontSize: 14,
                fontWeight: "bold",
                color: axisNameColor,
            },
            minInterval: 1,
            axisLine: {
                show: true,
                lineStyle: {
                    color: axisLineColor,
                    width: axisLineWidth,
                },
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: true,
                color: labelColor,
                fontSize: 11,
                rotate: 0,
            },
            splitLine: {
                show: false,
                lineStyle: {
                    color: "#ECECEC",
                },
            },
        },

        series: [
            {
                name: seriesLabel,
                type: "bar",
                data: graphData?.map(item =>
                    Number(item?.[yField] ?? 0)
                ),
                barWidth: 35,
                itemStyle: {
                    color: barColor,
                    borderRadius: [8, 8, 0, 0],
                },
                emphasis: {
                    itemStyle: {
                        color: "#2563EB",
                    },
                },
            },
        ],
    };

    return (
        <ChartCard
            title={chartLabel}
            height={height}
        >
            <ReactECharts
                option={option}
                notMerge={true}
                lazyUpdate={true}
                style={{
                    width: "100%",
                    height: "100%",
                }}
            />
        </ChartCard>
    );
};

export default BarChart;